import { useEffect, useState } from "react";
import "./printPrefactor.scss";
const PrintPrefactor = ({ titlePage = "", listPrint = [] }) => {
  const [list, setList] = useState([]);
  useEffect(() => {
    let filterData = listPrint.filter((item) => item);
    setList(filterData);
  }, [listPrint]);
  return (
    <>
      <div className="container-print">
        <div className="holder-box">
          <div className="holder-head">
            <h3>{titlePage}</h3>
          </div>
          <div className="holder-body">
            <div className="holder-list-pay">
              <ul>
                {list.map((item, key) => (
                  <li key={key}>
                    <div className="label">{item.label}</div>
                    <div className="value">{item.value}</div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PrintPrefactor;
